import { sleepUnlessAborted } from '@features/allocation';
import { keepPreviousData, queryOptions } from '@tanstack/react-query';
import { projectListService } from './services/projectListService';
import type { ManagerKind, ProjectFilters } from './types/ProjectList';

/** Mesma janela de debounce dos combos de alocação. */
const SEARCH_DEBOUNCE_MS = 300;

export const projectListQueries = {
  all: () => ['project-list'] as const,

  lists: () => [...projectListQueries.all(), 'list'] as const,
  list: (filters: ProjectFilters) =>
    queryOptions({
      queryKey: [...projectListQueries.lists(), filters] as const,
      queryFn: ({ signal }) => projectListService.list(filters, signal),
      placeholderData: keepPreviousData,
    }),

  managers: (kind: ManagerKind, search: string) =>
    queryOptions({
      queryKey: [...projectListQueries.all(), 'managers', kind, search] as const,
      queryFn: async ({ signal }) => {
        await sleepUnlessAborted(SEARCH_DEBOUNCE_MS, signal);
        return projectListService.listManagers(kind, search, signal);
      },
      placeholderData: keepPreviousData,
    }),
};
